import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'

export const ResetPasswordSuccess = () => {
    const { t } = useTranslation()

    return (
        <div className="auth-page">
            <div className="auth-card text-center">
                <div className="mb-4">
                    <img src="/images/logo-inicio.png" alt="logotipo" height={40} />
                </div>
                <div className="mb-4" style={{ fontSize: '48px', color: 'var(--success)' }}>
                    <i className="fas fa-check-circle"></i>
                </div>
                <h4 className="mb-4">{t('forgot.restoresuccess')}</h4>
                <Link to="/login" className="btn btn-primary">
                    {t('forgot.continue')}
                </Link>
            </div>
        </div>
    )    
}